// extracted by mini-css-extract-plugin
export default {"item":"ItemPopUpMenu_item__yEsbz","item__img":"ItemPopUpMenu_item__img__rpcGK","item__disc":"ItemPopUpMenu_item__disc__0HhdL"};